import { useSelector } from 'react-redux';
import { getProductCode } from '@api/store/products/actions';
import { BillingPaths, pathsParams } from '@api/services/dictionaries/paths';
import { toLower } from 'lodash-es';

export const usePlanListUrl = (): string => {
    const productCode = useSelector(getProductCode);
    return BillingPaths.BillingPlanList.replace(pathsParams.productCode, toLower(productCode));
};
